import { EventStreamMarshaller } from "./EventStreamMarshaller";
/** browser event stream serde utils provider */
export var eventStreamSerdeProvider = function (options) { return new EventStreamMarshaller(options); };
